import { useSizeProp } from '@lit-element/hooks'
import { buildProps, definePropType } from '@lit-element/utils'
import { random } from './hooks/number'

export const textInfo = {
  slideEnd: '请滑动到最后',
  slide: '请滑动到适当的位置',
  success: '验证成功',
  fail: '验证失败，请重试',
  doCaptcha: '请完成下面的验证',
  pointInOrder: '请按顺序点击',
  trigger: '点击进行验证',
  completed: '已完成验证',
}

export function parseTarget(target: any) {
  if (target === undefined || target === null) {
    return [random(75, 25), random(75, 25)]
  }

  const [targetX = random(75, 25), targetY = random(75, 25)] = Array.isArray(
    target
  )
    ? target
    : [target]

  return [targetX, targetY]
}

export const captchaProps = buildProps({
  type: {
    type: String,
    default: 'slide',
  },
  // 指示 Tooltip 的内容将附加在哪一个网页元素上
  appendTo: {
    type: definePropType<string | HTMLElement>([String, Object]),
  },
  // number | number[] 设置滑动目标位置，传入数组时第二位为纵向位置
  slideTarget: {
    type: [Number, Array],
    default: null,
    validator: (value: any) => {
      if (value === undefined || value === null) return true

      if (Array.isArray(value)) {
        return (
          value[0] >= 0 && value[0] <= 100 && value[1] >= 0 && value[1] <= 100
        )
      } else {
        return value >= 0 && value <= 100
      }
    },
  },
  title: String,
  tip: String,
  successTip: String,
  failTip: String,
  image: {
    type: [String, Function],
  },
  tolerance: {
    type: Number,
    default: 1,
    validator: (value: number) => value >= 0,
  },
  canvasSize: {
    type: Array,
    default: () => [1000, 600],
  },
  disabled: Boolean,
  loading: Boolean,
  onBeforeTest: Function,
  texts: Array,
  failLimit: {
    type: Number,
    default: 0,
  },
  remotePoint: Boolean,
  useTrigger: Boolean,
  triggerText: String,
  triggerSize: useSizeProp,
  visible: Boolean,
  isRefresh: Boolean,
  hollowShape: {
    type: [Function, String], // puzzle | shield | heart | ''
  },
  hideDelay: {
    type: Number,
    default: 2000,
    validator: (value: number) => value >= 0,
  },
} as const)

export const captchaSliderProps = buildProps({
  size: useSizeProp,
  target: {
    type: Number,
    default: 100,
    validator: (value: number) => value >= 0 && value <= 100,
  },
  tolerance: {
    type: Number,
    default: 1,
    validator: (value: number) => value >= 0,
  },
  disabled: Boolean,
  loading: Boolean,
  // loadingIcon: {
  //   isFunc: true,
  //   default: null,
  // },
  tip: String,
  successTip: String,
  loadingLock: Boolean,
  // loadingEffect: String, // as PropType<IconEffect>,
  onBeforeTest: Function,
  onSuccess: Function,
  onFail: Function,
  onDragStart: Function,
  onDrag: Function,
  onDragEnd: Function,
})
